import React from "react";
import arrow_icon from "../../images/table/Arrow_down.svg";

const NormalArrowFunction = React.forwardRef(function NormalArrowFunction(
  { className, style },
  ref,
) {
  return (
    <img
      ref={ref}
      src={arrow_icon}
      alt=""
      className={className}
      style={{
        width: 20,
        height: 20,
        marginRight: 12,
        pointerEvents: "none",
        transform: "rotate(0deg)",
        ...style,
      }}
    />
  );
});

export default NormalArrowFunction;
